import Config from "./config";
import axios from "axios";

/*AZURE METHOD NEW FOR 2026*/
import * as msal from "@azure/msal-browser"; 


function getRoles(allRoles) {
  let roles = [];
  console.log("All roles from token:", allRoles);
  
  const specificDivisionRole = allRoles.find((role) =>
    role.startsWith("Deviceconfiscation_Division"),
  );

  // Check for other roles as before
  const isAdmin =
    allRoles.includes("SpecialDiets_Admin") ||
    allRoles.includes("Deviceconfiscation_Admin") ||
    allRoles.includes("ASKIT_Admin");
  const isCampus = allRoles.includes("Deviceconfiscation_Campus");
  const isDistrict = allRoles.includes("Deviceconfiscation_District");
  const isAskITNews = allRoles.includes("ASKIT_News");

  // --- Build the final roles array ---

  if (isAdmin) {
    roles.push("Admin");
  }
  if (isAskITNews) {
    roles.push("ASKIT_News");
  }

  // If a specific division role was found, add it to the array
  if (specificDivisionRole) {
    // This will push the exact string, e.g., "Deviceconfiscation_DivisionNorth"
    roles.push(specificDivisionRole);
  }

  if (isCampus) {
    roles.push("Deviceconfiscation_Campus");
  }

  if (isDistrict) {
    roles.push("District");
  }

  return roles;
}

/*-APP FOR DEV ENVIRONMENT
const msalConfig = {
    auth: {
        clientId: "12287073-7e3b-4274-9cd8-ac93c158e8ed",
        authority: "https://login.microsoftonline.com/f5eb9966-9336-4b33-8895-9982425b13ed",
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage", // Try switching this to "sessionStorage" if local fails
        storeAuthStateInCookie: true,   // This helps fix the "flicker/loop" on IE/Edge/Chrome
    }
};
*/

/*-APP FOR PROD ENVIRONMENT*/
const msalConfig = {
    auth: {
        clientId: "a17200bd-995c-49ae-9071-052f661d8d8c",
        authority: "https://login.microsoftonline.com/f5eb9966-9336-4b33-8895-9982425b13ed",
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage", // Try switching this to "sessionStorage" if local fails
        storeAuthStateInCookie: true,   // This helps fix the "flicker/loop" on IE/Edge/Chrome
    }
};




// Add 'export' here
export const msalInstance = new msal.PublicClientApplication(msalConfig);

// Create a variable to track initialization
let isMsalInitialized = false;

async function initializeMsal() {
    if (!isMsalInitialized) {
        await msalInstance.initialize();
        isMsalInitialized = true;
    }
}

export class SharedApi {

static async login() {
    await initializeMsal();
    const loginRequest = { scopes: ["User.Read"] };
    try {
        // Use redirect instead of popup to avoid browser blocking
        await msalInstance.loginRedirect(loginRequest);
    } catch (error) {
        console.error("Login failed:", error);
    }
}




static async getUserProperties() {
    const delay = (ms) => new Promise(res => setTimeout(res, ms));

    try {
        await initializeMsal();
        
        // --- RETRY LOGIC ---
        let account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
        if (account) {
            console.log("Full Token Claims:", account.idTokenClaims); // Check this in console!
            const userRoles = account.idTokenClaims?.roles || [];
            console.log("User roles from token:", userRoles);
            // ...
        }
        
        if (!account) {
            console.log("Account not ready, waiting 500ms...");
            await delay(500); // Small wait for MSAL state to catch up
            account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
        }
        // -------------------

        if (!account) return { isAuthenticated: false };

        const userRoles = account.idTokenClaims?.roles || [];
        console.log("User roles from token:", userRoles);

        const tokenResponse = await msalInstance.acquireTokenSilent({
            scopes: ["User.Read"],
            account: account
        });

        const response = await fetch("https://graph.microsoft.com/v1.0/me", {
            headers: { Authorization: `Bearer ${tokenResponse.accessToken}` }
        });
        const graphData = await response.json();
        console.log("Graph API user data:", graphData);

        // DEFENSIVE MAPPING: Avoid calling .split on undefined
        const upn = graphData.userPrincipalName || "";
        const loginId = graphData.mailNickname || (upn.includes('@') ? upn.split('@')[0] : upn);
        //const loginId = graphData.mailNickname || (graphData.userPrincipalName?.split('@')[0]) || "";
        const employeeID = graphData.mailNickname || (graphData.userPrincipalName?.split('@')[0]) || "";

        return {
            isAuthenticated: true,
            user: {
                firstName: graphData.givenName || "",
                lastName: graphData.surname || "",
                fullName: graphData.displayName || "",
                employeeID:employeeID,
                loginId: loginId,
                roles: userRoles,
                campusID: graphData.officeLocation || "999",
                campusName: graphData.officeLocation || "999",
                staffNaturalKey:employeeID,
            }
        };
    } catch (error) {
        console.error("Auth Data Fetch Error:", error);
        return { isAuthenticated: false };
    }
}


/*

  static getUserProperties() {
    return new Promise((resolve, reject) => {
      let userProps = {};
      let user = {
        firstName: "",
        lastName: "",
        fullName: "",
        employeeID: "",
        role: "",
        roles: [],
        campusID: "",
        campusName: "",
      };
      let currentLoginPromise = this.getCurrentUserLogin();

      currentLoginPromise.then(function (currentUserLogin) {
        user.loginId = currentUserLogin.loginName.replace("AD\\", "");
        user.fullName = currentUserLogin.name;
        user.roles = getRoles(currentUserLogin.roles);
        user.role = user.roles[0];

        let staffInfoPromise = SharedApi.getUserByLoginID(user.loginId);
        staffInfoPromise.then(function (staffInfo) {
          if (staffInfo.value && staffInfo.value.length > 0) {
            user.firstName = staffInfo.value[0].FirstName;
            user.lastName = staffInfo.value[0].LastSurName;
            user.employeeID = staffInfo.value[0].EmployeeNumber;
            user.staffNaturalKey = staffInfo.value[0].StaffNaturalKey;
            user.campusID = staffInfo.value[0].EducationOrgNaturalKey;
            user.campusName =
              staffInfo.value[0].EducationOrganization.ShortNameOfInstitution;
            user.NameOfInstitution =
              staffInfo.value[0].EducationOrganization.NameOfInstitution;
            //user.acknowledgeEntry = fetchAknowledgementEmployeeStatus(staffInfo.value[0].StaffNaturalKey)
          }
          userProps.user = user;
          resolve(userProps);
        });
      });
    });
  }
    */

  static getCurrentUserLogin() {
    let serviceUrl = Config.REST_URL_AD_AUTH;
    const parameters = {
      method: "get",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: {
        AppID: "DAEP",
      },
    };

    return new Promise((resolve, reject) => {
      fetch(serviceUrl, parameters)
        .then(function (response) {
          resolve(response.json());
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  static getUserByLoginID(loginId) {
    let serviceUrl =
      Config.REST_URL_USER +
      "common/odata/Staffs?$filter=LoginId eq '" +
      loginId +
      "'&$expand=EducationOrganization";
    const parameters = {
      method: "get",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: {
        AppID: "DAEP",
      },
    };

    return new Promise((resolve, reject) => {
      fetch(serviceUrl, parameters)
        .then(function (response) {
          resolve(response.json());
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  static getCustomUserProperties(userID) {
    return new Promise((resolve, reject) => {
      let userProps = {};
      let user = {
        firstName: "",
        lastName: "",
        fullName: "",
        employeeID: "",
        role: "",
        roles: [],
        campusID: "",
        campusName: "",
      };
      let currentLoginPromise = this.getCustomCurrentUserLogin(userID);
      currentLoginPromise.then(function (currentUserLogin) {
        user.loginId = currentUserLogin.loginName.replace("AD\\", "");
        user.fullName = currentUserLogin.name;
        user.roles = getRoles(currentUserLogin.roles);
        user.role = user.roles[0];
        let staffInfoPromise = SharedApi.getUserByLoginID(user.loginId);
        //console.log(staffInfoPromise)
        staffInfoPromise.then(function (staffInfo) {
          if (staffInfo.value && staffInfo.value.length > 0) {
            user.firstName = staffInfo.value[0].FirstName;
            user.lastName = staffInfo.value[0].LastSurName;
            user.employeeID = staffInfo.value[0].EmployeeNumber;
            user.staffNaturalKey = staffInfo.value[0].StaffNaturalKey;
            user.campusID = staffInfo.value[0].EducationOrgNaturalKey;
            //user.campusName = staffInfo.value[0].EducationOrganization.NameOfInstitution;
            user.campusName =
              staffInfo.value[0].EducationOrganization.ShortNameOfInstitution;
            user.NameOfInstitution =
              staffInfo.value[0].EducationOrganization.NameOfInstitution;
          }
          userProps.user = user;
          resolve(userProps);
        });
      });
    });
  }

  static getCustomCurrentUserLogin(userID) {
    let serviceUrl =
      Config.REST_URL_USER +
      "common/api/SelectedUserInfo?username=" +
      userID +
      "";
    const parameters = {
      method: "get",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: {
        AppID: "DAEP",
      },
    };

    return new Promise((resolve, reject) => {
      fetch(serviceUrl, parameters)
        .then(function (response) {
          if (response.status !== 404)
            //or any status code really
            resolve(response.json());
          else {
            console.log("Error validating loginID");
            window.alert("Invalid LoginID...");
          }
        })
        .catch((error) => {
          console.log("Error validating loginID" + error.message);
        });
    });
  }


  /*azure */
  static getMockUserProperties() {
    return new Promise((resolve) => {
      // 1. Create your mock user object
      const user = {
        firstName: "lionel",
        lastName: "jones",
        fullname: "Lionel Jones",
        employeeID: "p00149021",
        loginId: "p00149021",
        staffNaturalKey: "p00149021",
        campusID: "999",
        campusName: "HATIE MAE WHITE",
        NameOfInstitution: "HATIE MAE WHITE",
        role: "Admin", // <--- Setting the role to Admin here
      };

      // 2. Wrap it in the userProps structure your app expects
      const userProps = {
        user: user,
        isAuthenticated: true, // Adding this in case your app checks a boolean
      };

      // 3. Resolve immediately with the mock data
      resolve(userProps);
    });
  }
}

/******SHOPPING CART */

export const fetchCandidateNominees = async () => {
  var url =
    Config.REST_URL +
    "dac/odata/CandidateNominees?$filter=VotingSettingID eq 14 and LocationID eq 1";
  console.log(url);
  try {
    return await axios.get(url).then((res) => {
      return res.data.value;
    });
  } catch (err) {
    console.log("Issue Fetching Records " + err);
    return [];
  }
};

export const fethECCSchoolData = async () => {
  var url = Config.LOCAL_HOST_API + "api/dac/getECCSchools";
  console.log(url);
  try {
    return await axios.get(url).then((res) => {
      return res.data;
    });
  } catch (err) {
    console.log("Issue Fetching Records " + err);
    return [];
  }
};

export const fethCartProductData = async () => {
  var url = Config.LOCAL_HOST_API + "api/products/fetchAllProducts";
  console.log(url);
  try {
    return await axios.get(url).then((res) => {
      //console.log(res.data);
      return res.data;
    });
  } catch (err) {
    console.log("Issue Fetching Records " + err);
    return [];
  }
};
